import { z } from 'zod'

// The `?case=` search parameter of /cases, validated by the route. Kept apart from cases-api.ts so the route,
// which is part of the initial bundle, does not pull in the API module.

/**
 * The selected case, lowercased because the server writes IDs in lowercase and the tree matches them exactly
 * (a link typed or pasted in capitals still selects its row). An invalid value is dropped instead of failing
 * the page.
 */
export const casesSearchSchema = z.object({ case: z.guid().toLowerCase().optional().catch(undefined) })
